<script>
    export let width = 60;
    export let height = 45;
    export let color = "#fff";
</script>

<svg {width} {height} viewBox="0 0 512 512">
    <circle
        cx="256"
        cy="256"
        r="96"
        fill="none"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="32"
    />
    <path
        fill="none"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="32"
        d="M160 256H48M464 256H352"
    />
</svg>
